import { render, staticRenderFns } from "./drag-drop.vue?vue&type=template&id=089914c1&"
import script from "./drag-drop.vue?vue&type=script&lang=js&"
export * from "./drag-drop.vue?vue&type=script&lang=js&"
import style0 from "./drag-drop.vue?vue&type=style&index=0&id=089914c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports